jQuery(document).ready(function(){
  jQuery('.accordion_tab_title .tabs .tab-link:first').addClass('current');
  jQuery('.accordion_tab_title .tabs .tab-link').click(function(){
    var tab_id = jQuery(this).attr('data-tab');

    jQuery('.accordion_tab_title .tabs .tab-link').removeClass('current');
    jQuery('.tab-content').removeClass('current');

    jQuery(this).addClass('current');
    jQuery("#"+tab_id).addClass('current');
  });

  jQuery("ul.tabs li a").click(function(e){
    //e.preventDefault();
  });

  globle();

  jQuery('.navmenu-submenu .meganav-inner .navmenu-meganav--scroller .navmenu-meganav-items li .site-nav__childlist-grid li.site-child-nav--active').parent().parent().parent().parent().parent().parent().parent().addClass('active_children');

});

jQuery(window).resize(function() {
  globle();
});

equalheight = function(container) {
  if (jQuery(window).width() > 481) {
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        jQueryel

    jQuery(container).each(function() {
      jQueryel = jQuery(this);
      jQuery(jQueryel).innerHeight('auto')
      rowDivs.push(jQueryel);
      currentTallest = (currentTallest < jQueryel.innerHeight()) ? (jQueryel.innerHeight()) : (currentTallest);

      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].innerHeight(currentTallest);
      }
    });
  } else {
    jQuery(container).height('auto');
  }
}


function globle() {
  // equalheight('.productgrid--outer .productgrid--wrapper ul.productgrid--items .productgrid--item article.productitem .productitem--info h2.productitem--title');
  /**/
  var announcement = jQuery(".site-announcement").outerHeight();
  var basicheader = jQuery(".site-header--basic").outerHeight();
  var menuh = jQuery(window).innerHeight() - announcement - basicheader; 
  var toph = announcement + basicheader
  console.log(toph);
  jQuery('.mobile-nav-panel').css("height", menuh + 'px'); 
  jQuery('.mobile-nav-panel').css("top", toph + 'px'); 

  /**/
}

jQuery(document).ready(function($) {
  jQuery('.site-mobile-nav .navmenu-meganav-item-parent').append('<div class="submenu-trigger"></div>')
  jQuery('.site-mobile-nav .submenu-trigger').click(function(event){
    jQuery('.site-mobile-nav .navmenu-meganav-item-parent.active-menu').removeClass('active-menu');
    jQuery(this).parent().toggleClass('active-menu');
    event.preventDefault();
  });
  jQuery('.site-mobile-nav .navmenu-meganav-item-parent').click(function(event){
    jQuery('.site-mobile-nav .navmenu-meganav-item-parent.active-menu').removeClass('active-menu');
    jQuery(this).toggleClass('active-menu');
  });

});

/* custom JS */ 
$(document).on("click",".size-values",function(e) {
  e.preventDefault();
  $('.size-values').removeClass('active');
  $(this).addClass('active');
});

$(document).on("click",".collection-ajax-btn",function(e) {
  e.preventDefault();
  var variant_div = $(this).closest('.hover-container').find('.active');
  var variant_id = variant_div.attr('id');
  var qty = 1;

  var data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      window.location.href = '/cart'; 
    }
  });
});


jQuery(document).ready(function(){
  var pageURL = jQuery(location).attr("href"),
      value = pageURL.indexOf('tagged');
  console.log(pageURL);

  if(value !== -1){
    jQuery('.blog_title_mn_otr .wrapper .blog_title_mn_inr ul li:first').removeClass('active');
  } else{

  }

});
//mini cart

$(document).ready(function(){
  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
    });
  }
  function refreshCart(cart) {
    $('.site-header-cart--count').text(cart.item_count);
    $('.site-header-cart--count').attr('data-header-cart-count',cart.item_count);

	  // Extend - listen for cart update
	  window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('refreshAjaxSideCart'))
    }, 500)
    // Extend - End code
  }

  $('body').on('click','.product-form--atc-button,.product-form__cart-submit',function(e){

    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    // btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        // btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      // btn.text('add to cart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('.productGrid .productItem').removeClass('qvopen');
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('cartOpen');
  });
  $('.site-header-cart-button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
  $('body').on('click', '.adjust',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      addToCartSuccess();
      $.getJSON("/cart.js", function(cart) {
        refreshCart(cart);
      });
      $('#crt').removeClass('loading');
    });

  });
  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount').text(c.item_count);
      if(!c.item_count) {
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      } else {
        addToCartSuccess();
      }
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });
});

//mini cart//

jQuery(document).ready(function(){
  jQuery(function(){
    new WOW().init(); 
  });
//   jQuery('#file-upload , input#fileupload_14').change(function() {
//     var filepath = this.value;
//     var m = filepath.match(/([^\/\\]+)$/);
//     var filename = m[1];
//     jQuery('label[for="fileupload_14"]').html(filename);
//   });
  function removeAttr(){
    if (window.matchMedia('(max-width: 1023px)').matches) {
      jQuery( ".mobile-nav-content ul li.navmenu-meganav-item-parent > a" ).each(function() {
        $(this).removeAttr("href");

      })
    }
  }

  jQuery(window).on("resize", removeAttr);
  jQuery(window).on("load", removeAttr);
  jQuery(window).on("orientationchange", removeAttr);
  
  
});

/* custom gift functionality  */ 

jQuery(document).ready(function(){
    $(document).on('click', ".single-addon", function(){
      	
      if(!$(this).hasClass('active-addon')){
      	var title = $(this).find('.addon-title').text();
        var addonId = $(this).find('.addon-id').val();
        var addonPrice = $(this).find('.addon-price').text();
        var addonFinalprice = parseInt(addonPrice.replace(/\$|,/g, ''));
        
      	var items_count = parseInt($('.active-addon').length);
        items_count += 1;
		var addonHtml = "<div class='addon-item' data-item-id='"+ addonId +"' data-item-price='"+ addonFinalprice +"'>";
        addonHtml += "<span class='item-index'>"+ items_count +"</span>";
        addonHtml += "<p class='item-title'>" + title + "</p>";
        addonHtml += "<div class='item--quantity'><input type='button' value='-' class='qtyMinus' field='itemQuantity'><input type='text' id='Quantity' name='itemQuantity'  value='1' min='1' class='product-form__input' pattern='[0-9]*'><input type='button' value='+' class='qtyPlus' field='itemQuantity'></div>";
        addonHtml += "</div>";
        $('.cart-addon-items').append(addonHtml); 
      }else{
      	var addonId = $(this).find('.addon-id').val();
		$('.addon-item[data-item-id='+ addonId +']').remove();
	  }
      	
      $(this).toggleClass('active-addon');
      
    });

	$(document).on('click', ".step-btn a", function(){
      	$(this).closest('.step-btn').addClass('hidden');
      	$('.second-step-btn').removeClass('hidden');
		$('.product_varient_div').addClass('hidden');
      	$('.step-container').removeClass('hidden');
    });
  
  	$(document).on('click', ".second-step-btn a", function(){
		var action = $(this).data('step');
        if(action == 'prev'){
          	$(this).closest('.second-step-btn').addClass('hidden');
			$('.product_varient_div').removeClass('hidden');
      		$('.step-container').addClass('hidden');
          	$('.step-btn').removeClass('hidden');
        }else{
          	$('.gift-board-form-fields').removeClass('hidden');
        	$('.buttons-container').removeClass('hidden');
          	$('.step-container').addClass('hidden');
          	$('.second-step-btn').addClass('hidden');
          	$('.cart-review-container').removeClass('hidden');
          	$('.product-form--atc').removeClass('hidden');
          	if($('.single-addon.active-addon').length > 0){
          		$('.addon-cart-details').removeClass('hidden');
          	}
          
          	var selected_price = $('select.form-options option:selected').text();
            var final_price = selected_price.split('-');
            var finalTotal = parseInt(final_price[1].replace('$',''));
            $('.cart-addon-items .addon-item').each(function(element) {
              var addonPrice = parseInt($(this).data('item-price'));
              var addonQty = $(this).find('#Quantity').val();
              var finalAddon = addonPrice * addonQty;
              console.log(finalAddon);
              finalTotal += finalAddon;
            });
            $('.final-set-price').text('$'+finalTotal);
          
        }
    });
  
  	$(document).on('click', ".change-variant", function(){
      	$('.second-step-btn').addClass('hidden');
        $('.product_varient_div').removeClass('hidden');
        $('.step-container').addClass('hidden');
        $('.step-btn').removeClass('hidden');
      	$('.gift-board-form-fields').addClass('hidden');
      	$('.buttons-container').addClass('hidden');
      	$('.cart-review-container').addClass('hidden');
    });
  
  	$(document).on('click', ".last-previews", function(){
      	$('.cart-review-container').addClass('hidden');
      	$('.gift-board-form-fields').addClass('hidden');
      	$('.product-form--atc').addClass('hidden');
      	$('.step-container').removeClass('hidden');
      	$('.second-step-btn').removeClass('hidden');
    });
  
});

$(document).on('click', ".qtyPlus", function(){	
    $(this).prev().val(+$(this).prev().val() + 1);
  
  	var currentTotal = $('.final-set-price').text();
    var finalTotal = parseInt(currentTotal.replace('$',''));
  
  	var thisAddonprice = parseInt($(this).closest('.addon-item').data('item-price'));
  	var finalPrice = finalTotal + thisAddonprice;
  	$('.final-set-price').text('$'+finalPrice);
  
});
$(document).on('click', ".qtyMinus", function(){
	if ($(this).next().val() > 1) {
    	$(this).next().val(+$(this).next().val() - 1);
      
      	var currentTotal = $('.final-set-price').text();
        var finalTotal = parseInt(currentTotal.replace('$',''));

        var thisAddonprice = parseInt($(this).closest('.addon-item').data('item-price'));
        var finalPrice = finalTotal - thisAddonprice;
        $('.final-set-price').text('$'+finalPrice);
      
    }
});

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

function addToCartOk(product) { 
   $.get( "/cart?view=mini", function( data ) {
     $('#crt').html(data);
   });
   $('body').addClass('cartOpen');
   $('.atc-button--text').text('Add to cart');
} 

function addToCartFail(obj, status) { 
    console.log('error',status);
} 

function addItem(form_id,bundle_id) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#'+form_id).serialize(),
      success: addToCartOk,
      error: addToCartFail
   });
}

$(document).on('click', ".gift-board-submit", function(e){
	e.preventDefault();
  	
     $(this).find('.atc-button--text').text('Adding...');
  	 var form_id = $(this).closest('form').attr('id');
  	 var bundle_id = makeid(1);
  	 $('.bundle_id').val(bundle_id);
  
  	 var available_ids = []; //array of 'varaint_id - qty'
    //the following loop was for my case, you need to change the DOM selector for yours
      $('.cart-addon-items .addon-item').each(function(){
      	var thisQty = $(this).find('#Quantity').val();
        if(thisQty > 0){
          	var xVarID = $(this).data('item-id');
          	var toPushItem = xVarID+'-'+thisQty;
          	available_ids.push(toPushItem);
        }
      }).promise().done( function(){ 
        
      }); //each qty ends      
      
    for (var i = 0; i < available_ids.length; i++) {
      
        (function(i){
              //we are applying setTimeout strategy to avoid fast looping what causes add to cart failure. 
            setTimeout(function(){
                  
                  //splitting the available_ids
                  var formContents = available_ids[i].split('-');
                  //[0] returns the variant id to add to cart
                  //[1] returns the quantity to add to cart
              	
              	  var data = {
                    "id": formContents[0],
                    "quantity": formContents[1],
                    "properties": {
                      'Add On' : bundle_id
                    }
                  }
              
                  var params = {
                      type: 'POST',
                      url: '/cart/add.js',
                      data: data,
                      dataType: 'json',
                      success: function(line_item) { 
                        console.log("success! - "+line_item.title);
      
                        var iteration_length = i+1;
                        //if iteration length is equal to the total length - it means that we have
                        //reached the last item. Now we redirect to cart or may be show pop up
                        if( iteration_length == available_ids.length ){ 
                          //redirect to cart or 
                          addItem(form_id,bundle_id);  
                          //do whatever
                        }
                      },
                      error: function() {
                          console.log("fail");
                      }
                  };
                  $.ajax(params); 
            }, 1000 * i);
              //1000*i means this code fires 1 seconds after each iteration which makes sure addition of add to cart is 
              //successful
        }(i));
    }
 
});

/* end custom gift functionality */ 
setTimeout(function(){
$(".product_varient_div select.form-options option").each(function( index, element ) {
	var price_text = $(element).text();
  	var final_price = price_text.split('-');
  	var option_title = $.trim(final_price[0]);
  		$('.option-price[data-option="'+ option_title +'"]').text(final_price[1]);  
});
}, 1200);  

/* gift slider start */
// $(document).ready(function(){
// $('.slider-main').slick({
//   slidesToShow: 1,
//   arrows: false,
//   asNavFor: '.slider-nav',
//   vertical: true,
//   autoplay: true,
//   verticalSwiping: true,
//   centerMode: true
// });

// $('.slider-nav').slick({
//   slidesToShow: 4,
//   asNavFor: '.slider-main',
//   vertical: true,
//   focusOnSelect: true,
//   autoplay: false,
//   centerMode: true
// });
  
// });  

// $(window).on('resize orientationchange', function() {
//   if ($(window).width() > 1200) {
//     $('.slider-nav').slick('unslick');
//     $('.slider-nav').slick({
//       slidesToShow: 4,
//       asNavFor: '.slider-main',
//       vertical: true,
//       focusOnSelect: true,
//       autoplay: false,
//       centerMode: true
//     });
//   }
// });

/* gift slider end */